import React from "react";
import Nav from "./Components/Nav";
import { Routes, Route } from "react-router-dom";
import HomePage from "./Components/HomePage/HomePage";
import Footer from "./Components/Footer";
import AboutPage from "./Components/AboutPage/AboutPage";
import Contact from "./Components/ContactPage/Contact";
import Blogs from "./Components/BlogPage/Blogs/Blogs";
import { AuthProvider } from "./context/AuthContext";
import BlogDetailPage from "./Components/BlogPage/Blogs/BlogDetailPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Faq from "./Components/faqpage/Faq";
import ErrorPage from "./Components/ErrorPage";
import { HelmetProvider } from "react-helmet-async";

function App() {
  const helmetContext = {};
  return (
    <>
      <AuthProvider>
        <HelmetProvider context={helmetContext}>
          <Nav />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/404" element={<ErrorPage />} />
            <Route path="/*" element={<ErrorPage />} />
          </Routes>
          <Footer />
          <ToastContainer />
        </HelmetProvider>
      </AuthProvider>
    </>
  );
}

export default App;
